import {GlobalVariables} from "../GlobalVariables";
import {gsap, ScrollTrigger} from "../LibrariesImport";

export default class BlockDivision {
    static init() {
        this.collapses = document.querySelectorAll(".block-division .item-division");
        this.build();
        GlobalVariables.resizeCallbacks.push(this);
    }

    static build() {

        this.collapses.forEach(collapse => {
            const head = collapse;
            const body = collapse.querySelector(".detail");
            body.dataset.height = body.clientHeight;
            body.style.height = 0;
            head.addEventListener("click", (evt) => {

                if (evt.target.closest('.btn-stroke')) {
                    return;
                }

                if (collapse.classList.contains("open")) {
                    collapse.classList.remove("open");
                    gsap.to(body, {
                        height: 0,
                        // duration: 0.3,
                        onComplete: () => ScrollTrigger.refresh()
                    });
                } else {
                    collapse.classList.add("open");
                    gsap.to(body, {
                        height: body.dataset.height,
                        // duration: 0.3,
                        onComplete: () => ScrollTrigger.refresh()
                    });
                }

            });
        });

    }

    static resize() {
        this.collapses.forEach(collapse => {
        	const body = collapse.querySelector(".detail");
            body.style.height = "auto";
            body.dataset.height = body.clientHeight;
        	body.style.height = "0";
            collapse.classList.remove("open");
        });
    }
}
